import { rm } from "@/lib/api";

const filled = (f, a) => (f.type === "checkbox" ? (a || []).length > 0 : !!(a && String(a).trim()));

export const missingFields = (fields, answers) =>
  Object.entries(fields || {}).flatMap(([pid, fs]) => fs.filter((f) => f.required && !filled(f, answers[pid]?.[f.id])).map((f) => f.label));

const price = (o) => (o.price_sen ? ` (+${rm(o.price_sen)})` : "");

function Field({ f, value, set, pid }) {
  const id = `cf-${pid}-${f.id}`;
  const label = <p className="text-xs font-semibold">{f.label}{f.required && <span className="text-red-500"> *</span>}</p>;
  if (f.type === "text") return (
    <label className="block space-y-1">{label}
      <input className="asv-input w-full" value={value || ""} placeholder={f.placeholder} maxLength={500} onChange={(e) => set(e.target.value)} data-testid={id} />
    </label>
  );
  const multi = f.type === "checkbox";
  const has = (oid) => (multi ? (value || []).includes(oid) : value === oid);
  const toggle = (oid) => set(multi ? (has(oid) ? value.filter((x) => x !== oid) : [...(value || []), oid]) : oid);
  return (
    <div className="space-y-1.5">{label}
      <div className="flex flex-wrap gap-2">{f.options.map((o) => (
        <button key={o.id} type="button" onClick={() => toggle(o.id)} data-testid={`${id}-${o.id}`}
          className={`rounded-full border px-3 py-1.5 text-xs font-semibold transition-colors ${has(o.id) ? "asv-accent border-current" : "asv-line asv-muted"}`}>
          {o.label}{price(o)}</button>))}</div>
    </div>
  );
}

export function CartFields({ fields, names, vendor, answers, onChange }) {
  const list = Object.entries(fields || {});
  if (!list.length) return null;
  const set = (pid, fid) => (v) => onChange({ ...answers, [pid]: { ...(answers[pid] || {}), [fid]: v } });
  return (
    <div className="asv-card space-y-4 p-4" data-testid="cart-fields">
      <p className="text-sm font-bold">Details for {vendor}</p>
      {list.map(([pid, fs]) => (
        <div key={pid} className="space-y-3" data-testid={`cart-fields-${pid}`}>
          {list.length > 1 && <p className="asv-muted text-xs font-semibold uppercase tracking-wide">{names[pid] || "Venue"}</p>}
          {fs.map((f) => <Field key={f.id} f={f} pid={pid} value={answers[pid]?.[f.id]} set={set(pid, f.id)} />)}
        </div>
      ))}
      <p className="asv-muted text-[11px]">Your answers are sent to {vendor} with the booking.</p>
    </div>
  );
}
